import { render, staticRenderFns } from "./CalabozoDetail.vue?vue&type=template&id=6a7190da&scoped=true"
import script from "./CalabozoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CalabozoDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CalabozoDetail.vue?vue&type=style&index=0&id=6a7190da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7190da",
  null
  
)

export default component.exports